// Movies List Names
export const NOW_PLAYING = "now_playing";
export const POPULAR = "popular";
export const TOP_RATED = "top_rated";
export const UPCOMING = "upcoming";
export const MOVIES_LIST = [NOW_PLAYING, POPULAR, TOP_RATED, UPCOMING];
export const TMDB_IMG_BASE_URL = "https://image.tmdb.org/t/p/w500";

// Navigation button text values
export const GPT_SEARCH = "GPT Search";
export const BROWSE = "Browse";

// TMDB
export const TMDB_API_OPTION = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_TMDB_API_READ_ACCESS_TOKEN}`,
  },
};

export const getMoviesListURL = (
  listname = NOW_PLAYING,
  language = "en-US",
  region = "US"
) => {
  return `https://api.themoviedb.org/3/movie/${listname}?language=${language}&page=1&region=${region}`;
};

export const getMovieVideosUrl = (movieID) => {
  return `https://api.themoviedb.org/3/movie/${movieID}/videos`;
};

export const getMovieSearchUrl = (movieName) => {
  return `https://api.themoviedb.org/3/search/movie?query=${movieName}&include_adult=false&page=1`;
};
